import { CheckEnvironment, SupportedEnvironments } from './environment';

const BRAND_COOKIE_NAME = 'dev-brand-override';
const COOKIE_EXPIRY_DAYS = 30;

/**
 * Get the brand from cookie (development only)
 */
export function getBrandFromCookie(): string | null {
  if (!CheckEnvironment(SupportedEnvironments.Dev)) {
    return null;
  }

  const cookies = document.cookie.split(';');
  const brandCookie = cookies.find(cookie =>
    cookie.trim().startsWith(`${BRAND_COOKIE_NAME}=`)
  );

  if (brandCookie) {
    return decodeURIComponent(brandCookie.split('=')[1]);
  }

  return null;
}

/**
 * Set the brand in cookie (development only)
 */
export function setBrandCookie(brandDomain: string): void {
  if (!CheckEnvironment(SupportedEnvironments.Dev)) {
    return;
  }

  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + COOKIE_EXPIRY_DAYS);

  document.cookie = `${BRAND_COOKIE_NAME}=${encodeURIComponent(brandDomain)}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
}

/**
 * Clear the brand cookie (development only)
 */
export function clearBrandCookie(): void {
  if (!CheckEnvironment(SupportedEnvironments.Dev)) {
    return;
  }

  document.cookie = `${BRAND_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
}

/**
 * Check if a brand is set in cookie (development only)
 */
export function hasBrandCookie(): boolean {
  return getBrandFromCookie() !== null;
}
